jQuery(document).ready(function ($) {
	if ($("body").hasClass("page-template-page-press-releases-2023")) {
		//Global script variables

		// Set up AJAX request
		var ajaxurl = "/wp-admin/admin-ajax.php";
		var pageNumber = 1;
		var postsPerPage = 6;
		var blogId = $('#posts-container').attr("data-current-blog-id");
		var currentYear = $('#posts-container').attr("data-current-year");
		var newYear = false;

		// Function to load more posts
		function loadPosts() {
			// Make AJAX request
			$.ajax({
				url: ajaxurl,
				type: "POST",
				data: {
					action: "load_more_press_release_posts",
					pageNumber: pageNumber,
					postsPerPage: postsPerPage,
					blogId: blogId,
					currentYear: currentYear,
				},
				success: function (response) {
					// Remove loading classes
					$('.year-nav').removeClass('is-loading');
					$('.load-more-posts').removeClass("is-loading");
					$('.load-more-section').removeClass('is-loading');
					$('.load-more-posts').show();
					$('.load-posts-by-year').each(function() {
						$(this).removeClass('is-loading');
					});
					// Append posts to container
					if ( newYear === true ) {
						$("#posts-container").html(response);
						pageNumber = 2;
						newYear = false;
					} else {
						$("#posts-container").append(response);
						pageNumber++;
					}
				}
			});
		}

		// Load initial posts
		loadPosts();

		// Attach click event to load more button
		$(".load-more-posts").click(function () {
			event.preventDefault();
			newYear = false;
			$('.load-more-section').addClass('is-loading');
			$('.load-more-posts').addClass("is-loading");
			loadPosts();
		});

		// Attach click event to year nav buttons
		$(".load-posts-by-year").click(function () {
			event.preventDefault();
			currentYear = $(this).attr("data-nav-year");
			pageNumber = 1;
			newYear = true;
			$('.load-more-posts').prop('disabled', false);
			$('.load-more-posts').addClass('is-loading');
			$('.year-nav').addClass('is-loading');
			$('.load-more-section').addClass('is-loading');
			$('.load-posts-by-year').each(function() {
				$(this).removeClass('active');
			});
			$(this).addClass('active is-loading');
			loadPosts();
		});

		// Create a new observer
		var observer = new MutationObserver(function(mutations) {
			// Disable Load More button if we run out of posts to display.
			$('.last-post-count').each(function() {
				if ($(this).attr("data-post-count") < postsPerPage) {
					$('.load-more-posts').prop('disabled', true);
				}
			});
			// Disable Load More button if no posts are found.
			if ($('.no-posts-message').length) {
				// Element exists, do something
				$('.load-more-posts').hide();
			}

		});

		// Observe the document for changes
		observer.observe(document, { subtree: true, childList: true });

	}
});
